import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../components/header";
import ContainerComponent from "../../components/conatiner";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import InputComponent from "../../components/input";
import { FormEvent, useEffect, useState } from "react";
import TableComponent from "../../components/table";
import { CostCenterAddEmployeeService, CostCenterShowService } from "../../services/center_cost";
import { ToastErro, ToastSucesso } from "../../components/toast";
import LoadingComponent from "../../components/loading";
import ModalComponent from "../../components/modal";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const CostCentersInfoPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const { id } = useParams();

    const [costCenter, setCostCenter] = useState<any>(null);
    const [approvers, setApprovers] = useState<any>([]);
    const [employees, setEmployees] = useState<any>([]);
    const [employeesNotRegistered, setEmployeesNotRegistered] = useState<any>([]);

    const [employee, setEmployee] = useState<number>(null!);

    // função para pesquisar dados do rdi
    const getData = async () => {

        setLoading(true);

        await CostCenterShowService(parseInt(id!)).then(resp => {
            setCostCenter(resp.data.cost_center);
            setApprovers(resp.data.approvers);
            setEmployees(resp.data.employees);
            setEmployeesNotRegistered(resp.data.employeesNotRegistered);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar dados do rdi

    // função para salvar funcionário
    const saveEmployee = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        (window as any).$("#modalAdd").modal('hide');

        setLoading(true);

        await CostCenterAddEmployeeService(parseInt(id!), employee).then(resp => {
            ToastSucesso(resp.data.message);
            setEmployee(null!);
            getData();
        }).catch(error => {
            ToastErro('Ocorreu um erro ao tentar adicionar um funcionário no centro de custo!');
            setLoading(false);
        });

    }
    // função para salvar funcionário

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Informações do Centro de Custo"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/cost_centers')}
                button2="Funcionário"
                iconButton2="add"
                onClick2={() => (window as any).$("#modalAdd").modal('show')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Informações do Centro de Custo"
                    >
                        {
                            loading

                                ?

                                <LoadingComponent />

                                :

                                <div className="row">
                                    <InputComponent
                                        label="Descrição"
                                        col={6}
                                        defaultValue={costCenter.description}
                                        disabled
                                    />
                                    <InputComponent
                                        label="Filial"
                                        col={3}
                                        defaultValue={costCenter.branch}
                                        disabled
                                    />
                                    <InputComponent
                                        label="Qtd. de Níveis"
                                        col={3}
                                        defaultValue={costCenter.approval_levels}
                                        disabled
                                    />
                                </div>
                        }
                    </CardHeaderBackgroundComponent>

                    <div className="row">
                        <div className="col-md-6">
                            <TableComponent
                                title="Aprovadores"
                                columns={['ID', 'Nome', 'Nível']}
                                loading={loading}
                            >
                                {
                                    approvers.map((a: any) => {
                                        return (
                                            <tr key={a.id}>
                                                <td className="pc-4">{a.id}</td>
                                                <td className="pc-4">{a.name}</td>
                                                <td className="pc-4">{a.level}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </TableComponent>
                        </div>
                        <div className="col-md-6">
                            <TableComponent
                                title="Funcionários"
                                columns={['ID', 'Nome']}
                                loading={loading}
                            >
                                {
                                    employees.map((e: any) => {
                                        return (
                                            <tr key={e.id}>
                                                <td className="px-4">{e.id}</td>
                                                <td className="px-4">{e.name}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </TableComponent>
                        </div>
                    </div>

                    <ModalComponent
                        title="Adicionat Funcionário"
                        id="modalAdd"
                    >
                        <form onSubmit={saveEmployee}>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <FormControl fullWidth>
                                        <InputLabel>Funcionário</InputLabel>
                                        <Select
                                            label="Funcionário"
                                            value={employee}
                                            onChange={(e: any) => setEmployee(e.target.value)}
                                        >
                                            {
                                                employeesNotRegistered.map((e: any) => {
                                                    return <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">Salvar</button>
                            </div>
                        </form>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default CostCentersInfoPage;